module.exports = __webpack_public_path__ + "static/img/beijing3.093e65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/beijing3.png
// module id = v8ib
// module chunks = 1